<template>
  <LineChartGenerator :chart-data="chartData" :chart-options="chartOptions" />
</template>

<script>
import "chartjs-adapter-moment";
import { Line as LineChartGenerator } from "vue-chartjs/legacy";
import {
  Chart as ChartJS,
  Filler,
  Legend,
  LineElement,
  LinearScale,
  PointElement,
  TimeScale,
  Title,
  Tooltip
} from "chart.js";

ChartJS.register(
  Filler,
  Legend,
  LineElement,
  LinearScale,
  PointElement,
  TimeScale,
  Title,
  Tooltip
);
export default {
  name: "Stats",
  components: { LineChartGenerator },
  props: ["chartData", "chartOptions"]
};
</script>
